export const userRoles = [
    'alternative-contact',
    'debtor',
    'client',
    'caseworker',
    'admin',
    'super-admin',
];
export const roles = [...userRoles, 'unauthorized'];
export const selectableRolesForUpdateUser = roles
    .filter((r) => ['client', 'caseworker', 'admin'].includes(r))
    .map((r) => r);
//# sourceMappingURL=roles.js.map